// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cal-root {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--bg-primary);
  color: var(--text-primary);
  overflow: hidden;
}

/* ── Toolbar ───────────────────────────────────────────── */
.cal-toolbar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.cal-toolbar-title {
  font-size: 15px;
  font-weight: 600;
  min-width: 180px;
  text-align: center;
}

.cal-toolbar-spacer { flex: 1; }

.cal-btn {
  background: none;
  border: 1px solid var(--border);
  color: var(--text-primary);
  padding: 3px 10px;
  border-radius: 3px;
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}
.cal-btn:hover { background: var(--bg-hover); }
.cal-btn.active { background: var(--accent); border-color: var(--accent); color: #fff; }
.cal-btn-icon {
  background: none;
  border: none;
  color: var(--text-secondary);
  padding: 3px 6px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  border-radius: 3px;
}
.cal-btn-icon:hover { color: var(--text-primary); background: var(--bg-hover); }

.cal-view-group { display: flex; gap: 2px; }

.cal-nav-group {
  display: flex;
  align-items: center;
}

/* ── Month view ─────────────────────────────────────────── */
.cal-month {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cal-month-header {
  display: grid;
  grid-template-columns: 28px repeat(7, 1fr);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}
.cal-wk-header-label {
  font-size: 10px;
  color: var(--text-muted);
  text-align: center;
  padding: 4px 0;
  text-transform: uppercase;
  border-right: 1px solid var(--border);
}
.cal-month-dow {
  text-align: center;
  font-size: 11px;
  color: var(--text-secondary);
  padding: 4px 0;
  text-transform: uppercase;
}

.cal-month-grid {
  flex: 1;
  display: grid;
  grid-template-columns: 28px repeat(7, 1fr);
  grid-auto-rows: 1fr;
  overflow: hidden;
}

.cal-wk-num {
  font-size: 10px;
  color: var(--text-muted);
  text-align: center;
  padding-top: 6px;
  border-right: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  cursor: pointer;
  user-select: none;
}
.cal-wk-num:hover { color: var(--accent-light); }

.cal-month-cell {
  border-right: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
  padding: 3px 4px;
  min-height: 0;
  overflow: hidden;
  cursor: pointer;
  position: relative;
}
.cal-month-cell:hover { background: rgba(255,255,255,0.03); }
.cal-month-cell.other-month .cal-day-num { color: var(--text-muted); }
.cal-month-cell.today .cal-day-num {
  background: var(--accent);
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cal-day-num {
  font-size: 11px;
  color: var(--text-secondary);
  margin-bottom: 2px;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cal-month-event {
  font-size: 11px;
  padding: 1px 4px;
  border-radius: 2px;
  margin-bottom: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  color: #fff;
}
.cal-month-event:hover { filter: brightness(1.15); }

.cal-more-link {
  font-size: 10px;
  color: var(--text-muted);
  cursor: pointer;
  padding: 0 4px;
}
.cal-more-link:hover { color: var(--text-primary); }

/* ── Week view ──────────────────────────────────────────── */
.cal-week {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cal-week-header {
  display: grid;
  grid-template-columns: 48px repeat(7, 1fr);
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}
.cal-week-header-gutter { border-right: 1px solid var(--border); }
.cal-wk-num-header {
  font-size: 10px;
  color: var(--text-muted);
  text-align: center;
  padding: 4px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.cal-week-header-day {
  text-align: center;
  padding: 4px 2px;
  font-size: 12px;
  border-right: 1px solid var(--border);
}
.cal-week-header-day .dow { color: var(--text-secondary); font-size: 10px; text-transform: uppercase; display: block; }
.cal-week-header-day .dom {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
}
.cal-week-header-day.today .dom { background: var(--accent); color: #fff; }

.cal-week-body {
  flex: 1;
  display: grid;
  grid-template-columns: 48px repeat(7, 1fr);
  overflow-y: auto;
  overflow-x: hidden;
}

.cal-week-time-col {
  border-right: 1px solid var(--border);
  position: relative;
}
.cal-hour-label {
  font-size: 10px;
  color: var(--text-muted);
  text-align: right;
  padding-right: 4px;
  height: 48px;
  line-height: 1;
  padding-top: 2px;
  box-sizing: border-box;
}

.cal-week-day-col {
  border-right: 1px solid var(--border);
  position: relative;
  cursor: pointer;
}
.cal-week-day-col:hover { background: rgba(255,255,255,0.015); }
.cal-hour-line {
  border-top: 1px solid var(--border);
  height: 48px;
  box-sizing: border-box;
  pointer-events: none;
}

.cal-week-event {
  position: absolute;
  left: 2px;
  right: 2px;
  border-radius: 3px;
  padding: 2px 4px;
  font-size: 11px;
  overflow: hidden;
  cursor: pointer;
  color: #fff;
  box-sizing: border-box;
  z-index: 1;
}
.cal-week-event:hover { filter: brightness(1.15); z-index: 2; }

/* ── Day view ───────────────────────────────────────────── */
.cal-day {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.cal-day-header {
  text-align: center;
  padding: 6px;
  font-size: 14px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.cal-day-body {
  flex: 1;
  display: grid;
  grid-template-columns: 48px 1fr;
  overflow-y: auto;
}

.cal-day-event-col {
  position: relative;
  cursor: pointer;
}
.cal-day-event-col:hover { background: rgba(255,255,255,0.015); }

.cal-day-event {
  position: absolute;
  left: 4px;
  right: 4px;
  border-radius: 3px;
  padding: 3px 6px;
  font-size: 12px;
  overflow: hidden;
  cursor: pointer;
  color: #fff;
  box-sizing: border-box;
}
.cal-day-event:hover { filter: brightness(1.15); }

/* ── Event form modal ────────────────────────────────────── */
.cal-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.cal-modal {
  background: var(--bg-secondary);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 20px;
  width: 480px;
  max-width: 96vw;
  max-height: 90vh;
  overflow-y: auto;
}

.cal-modal h3 {
  margin: 0 0 16px;
  font-size: 15px;
  font-weight: 600;
}

.cal-form-row {
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.cal-form-row label {
  font-size: 11px;
  color: var(--text-secondary);
  text-transform: uppercase;
}
.cal-form-row input,
.cal-form-row select,
.cal-form-row textarea {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  color: var(--text-primary);
  border-radius: 3px;
  padding: 5px 8px;
  font-size: 13px;
  width: 100%;
  box-sizing: border-box;
}
.cal-form-row textarea { resize: vertical; min-height: 60px; }
.cal-form-row input:focus, .cal-form-row select:focus, .cal-form-row textarea:focus {
  outline: none;
  border-color: var(--accent);
}

.cal-form-inline {
  display: flex;
  gap: 8px;
  align-items: center;
}
.cal-form-inline input[type="checkbox"] { width: auto; }
.cal-form-inline label { font-size: 13px; color: var(--text-primary); text-transform: none; }

.cal-color-row {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 4px;
}
.cal-color-swatch {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  cursor: pointer;
  border: 2px solid transparent;
}
.cal-color-swatch.selected { border-color: #fff; }

.cal-recur-section {
  border: 1px solid var(--border);
  border-radius: 4px;
  padding: 10px;
  margin-top: 4px;
}
.cal-recur-row {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 8px;
  flex-wrap: wrap;
}
.cal-recur-row:last-child { margin-bottom: 0; }
.cal-recur-row label { font-size: 12px; color: var(--text-secondary); white-space: nowrap; }
.cal-recur-row input, .cal-recur-row select {
  background: var(--bg-primary);
  border: 1px solid var(--border);
  color: var(--text-primary);
  border-radius: 3px;
  padding: 3px 6px;
  font-size: 12px;
}


.cal-modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 16px;
}
.cal-modal-actions .btn-danger {
  margin-right: auto;
}

/* ── All-day row in week/day ────────────────────────────── */
.cal-allday-row {
  display: grid;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
  min-height: 24px;
}
.cal-allday-gutter {
  border-right: 1px solid var(--border);
  font-size: 10px;
  color: var(--text-muted);
  padding: 3px 4px;
  text-align: right;
}
.cal-allday-cell {
  border-right: 1px solid var(--border);
  padding: 2px 2px;
  min-height: 24px;
}
.cal-allday-event {
  font-size: 11px;
  padding: 1px 4px;
  border-radius: 2px;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  margin-bottom: 1px;
}

/* ── Now line ───────────────────────────────────────────── */
.cal-now-line {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background: #e74c3c;
  z-index: 5;
  pointer-events: none;
}
.cal-now-line::before {
  content: '';
  position: absolute;
  left: -4px;
  top: -4px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #e74c3c;
}

@media (max-width: 768px) {
  .cal-toolbar {
    flex-wrap: wrap;
    gap: 6px;
  }
  .cal-toolbar-title { min-width: 0; font-size: 13px; text-align: center; flex: 1; }
  .cal-nav-group {
    order: 10;
    width: 100%;
    justify-content: center;
    border-top: 1px solid var(--border);
    padding-top: 6px;
  }
  .cal-month-event { font-size: 10px; }
  .cal-month-event-time { display: none; }
  .cal-modal { padding: 14px; }
}


/* ── KSE Pro additions ──────────────────────────────────── */
.cal-btn { display: inline-flex; align-items: center; gap: 4px; }
.cal-btn:disabled { opacity: .5; cursor: default; }
.cal-new-btn { display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; }
.cal-month-cell.weekend { background: rgba(127,127,127,0.04); }
.cal-event-loc { opacity: .85; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.cal-week-event strong { display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.cal-error { padding: 6px 12px; font-size: 12px; color: #f48771; border-bottom: 1px solid var(--border); }

.cal-picker-wrap { position: relative; }
.cal-picker {
  position: absolute; right: 0; top: calc(100% + 4px); z-index: 50;
  width: 280px; max-height: 60vh; overflow-y: auto;
  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: 6px;
  box-shadow: 0 8px 24px rgba(0,0,0,.35); padding: 6px 0;
}
.cal-pick-section { font-size: 10px; text-transform: uppercase; letter-spacing: .06em; color: var(--text-muted); padding: 8px 12px 4px; }
.cal-pick-row { display: flex; align-items: center; gap: 8px; padding: 5px 12px; font-size: 13px; cursor: pointer; }
.cal-pick-row:hover { background: var(--bg-hover); }
.cal-pick-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; border: 1px solid var(--border); }
.cal-pick-label { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.cal-pick-empty { padding: 4px 12px; font-size: 12px; color: var(--text-muted); }

.cal-form-pair { display: grid; grid-template-columns: 1fr; }
.cal-dt { display: flex; gap: 6px; }
.cal-dt input[type="date"] { flex: 1; min-width: 0; }
.cal-dt input[type="time"] { width: 120px; flex-shrink: 0; }
.cal-form-hint { font-size: 11px; color: var(--text-muted); }
.cal-form-note { font-size: 12px; color: var(--text-muted); margin: -8px 0 12px; }
.cal-form-error { font-size: 12px; color: #f48771; margin-top: 4px; }
.cal-color-default { position: relative; }
.cal-color-default::after { content: ''; position: absolute; inset: 6px; border-radius: 50%; background: rgba(255,255,255,.85); }
.cal-view-row { font-size: 13px; margin-bottom: 8px; line-height: 1.45; }
.cal-view-muted { color: var(--text-muted); font-size: 12px; }
.cal-view-desc { white-space: pre-wrap; color: var(--text-secondary); }

@media (max-width: 768px) {
  .cal-picker { position: fixed; left: 8px; right: 8px; top: 100px; width: auto; max-height: 70vh; }
  .cal-month-cell { padding: 2px; }
  .cal-month-event { padding: 0 2px; }
  .cal-week-event { font-size: 10px; padding: 1px 2px; }
  .cal-event-loc { display: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/calendar/Calendar.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,sBAAsB,OAAO,EAAE;;AAE/B;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;AACA,iBAAiB,2BAA2B,EAAE;AAC9C,kBAAkB,yBAAyB,EAAE,2BAA2B,EAAE,WAAW,EAAE;AACvF;EACE,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA,sBAAsB,0BAA0B,EAAE,2BAA2B,EAAE;;AAE/E,kBAAkB,aAAa,EAAE,QAAQ,EAAE;;AAE3C;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,8DAA8D;AAC9D;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,sCAAsC;EACtC,eAAe;EACf,iBAAiB;AACnB;AACA,oBAAoB,0BAA0B,EAAE;;AAEhD;EACE,qCAAqC;EACrC,sCAAsC;EACtC,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA,wBAAwB,kCAAkC,EAAE;AAC5D,2CAA2C,wBAAwB,EAAE;AACrE;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;AACA,yBAAyB,wBAAwB,EAAE;;AAEnD;EACE,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,cAAc;AAChB;AACA,uBAAuB,0BAA0B,EAAE;;AAEnD,8DAA8D;AAC9D;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,sCAAsC;EACtC,cAAc;AAChB;AACA,0BAA0B,qCAAqC,EAAE;AACjE;EACE,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qCAAqC;AACvC;AACA,4BAA4B,4BAA4B,EAAE,eAAe,EAAE,yBAAyB,EAAE,cAAc,EAAE;AACtH;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA,kCAAkC,yBAAyB,EAAE,WAAW,EAAE;;AAE1E;EACE,OAAO;EACP,aAAa;EACb,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;AACjB;AACA,0BAA0B,mCAAmC,EAAE;AAC/D;EACE,mCAAmC;EACnC,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,UAAU;AACZ;AACA,wBAAwB,wBAAwB,EAAE,UAAU,EAAE;;AAE9D,8DAA8D;AAC9D;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA,2BAA2B,mCAAmC,EAAE;;AAEhE;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;AACA,uBAAuB,wBAAwB,EAAE;;AAEjD,+DAA+D;AAC/D;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,yBAAyB;AAC3B;AACA;;;EAGE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;AACA,yBAAyB,gBAAgB,EAAE,gBAAgB,EAAE;AAC7D;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;AACA,0CAA0C,WAAW,EAAE;AACvD,yBAAyB,eAAe,EAAE,0BAA0B,EAAE,oBAAoB,EAAE;;AAE5F;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;AACA,6BAA6B,kBAAkB,EAAE;;AAEjD;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;AACA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;AACA,4BAA4B,gBAAgB,EAAE;AAC9C,uBAAuB,eAAe,EAAE,4BAA4B,EAAE,mBAAmB,EAAE;AAC3F;EACE,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,sCAAsC;EACtC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA,8DAA8D;AAC9D;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,QAAQ;EACV;EACA,qBAAqB,YAAY,EAAE,eAAe,EAAE,kBAAkB,EAAE,OAAO,EAAE;EACjF;IACE,SAAS;IACT,WAAW;IACX,uBAAuB;IACvB,mCAAmC;IACnC,gBAAgB;EAClB;EACA,mBAAmB,eAAe,EAAE;EACpC,wBAAwB,aAAa,EAAE;EACvC,aAAa,aAAa,EAAE;AAC9B;;;AAGA,8DAA8D;AAC9D,WAAW,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAChE,oBAAoB,WAAW,EAAE,eAAe,EAAE;AAClD,eAAe,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,mBAAmB,EAAE;AACzF,0BAA0B,kCAAkC,EAAE;AAC9D,iBAAiB,YAAY,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AAC/F,yBAAyB,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE;AACzG,aAAa,iBAAiB,EAAE,eAAe,EAAE,cAAc,EAAE,sCAAsC,EAAE;;AAEzG,mBAAmB,kBAAkB,EAAE;AACvC;EACE,kBAAkB,EAAE,QAAQ,EAAE,qBAAqB,EAAE,WAAW;EAChE,YAAY,EAAE,gBAAgB,EAAE,gBAAgB;EAChD,+BAA+B,EAAE,+BAA+B,EAAE,kBAAkB;EACpF,sCAAsC,EAAE,cAAc;AACxD;AACA,oBAAoB,eAAe,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,wBAAwB,EAAE,qBAAqB,EAAE;AACxI,gBAAgB,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,iBAAiB,EAAE,eAAe,EAAE,eAAe,EAAE;AACnH,sBAAsB,2BAA2B,EAAE;AACnD,gBAAgB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,cAAc,EAAE,+BAA+B,EAAE;AAChH,kBAAkB,OAAO,EAAE,YAAY,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AACzG,kBAAkB,iBAAiB,EAAE,eAAe,EAAE,wBAAwB,EAAE;;AAEhF,iBAAiB,aAAa,EAAE,0BAA0B,EAAE;AAC5D,UAAU,aAAa,EAAE,QAAQ,EAAE;AACnC,6BAA6B,OAAO,EAAE,YAAY,EAAE;AACpD,6BAA6B,YAAY,EAAE,cAAc,EAAE;AAC3D,iBAAiB,eAAe,EAAE,wBAAwB,EAAE;AAC5D,iBAAiB,eAAe,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;AACjF,kBAAkB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;AACpE,qBAAqB,kBAAkB,EAAE;AACzC,4BAA4B,WAAW,EAAE,kBAAkB,EAAE,UAAU,EAAE,kBAAkB,EAAE,iCAAiC,EAAE;AAChI,gBAAgB,eAAe,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACxE,kBAAkB,wBAAwB,EAAE,eAAe,EAAE;AAC7D,iBAAiB,qBAAqB,EAAE,4BAA4B,EAAE;;AAEtE;EACE,cAAc,eAAe,EAAE,SAAS,EAAE,UAAU,EAAE,UAAU,EAAE,WAAW,EAAE,gBAAgB,EAAE;EACjG,kBAAkB,YAAY,EAAE;EAChC,mBAAmB,cAAc,EAAE;EACnC,kBAAkB,eAAe,EAAE,gBAAgB,EAAE;EACrD,iBAAiB,aAAa,EAAE;AAClC","sourcesContent":[".cal-root {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: var(--bg-primary);\n  color: var(--text-primary);\n  overflow: hidden;\n}\n\n/* ── Toolbar ───────────────────────────────────────────── */\n.cal-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.cal-toolbar-title {\n  font-size: 15px;\n  font-weight: 600;\n  min-width: 180px;\n  text-align: center;\n}\n\n.cal-toolbar-spacer { flex: 1; }\n\n.cal-btn {\n  background: none;\n  border: 1px solid var(--border);\n  color: var(--text-primary);\n  padding: 3px 10px;\n  border-radius: 3px;\n  font-size: 12px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n.cal-btn:hover { background: var(--bg-hover); }\n.cal-btn.active { background: var(--accent); border-color: var(--accent); color: #fff; }\n.cal-btn-icon {\n  background: none;\n  border: none;\n  color: var(--text-secondary);\n  padding: 3px 6px;\n  cursor: pointer;\n  font-size: 16px;\n  line-height: 1;\n  border-radius: 3px;\n}\n.cal-btn-icon:hover { color: var(--text-primary); background: var(--bg-hover); }\n\n.cal-view-group { display: flex; gap: 2px; }\n\n.cal-nav-group {\n  display: flex;\n  align-items: center;\n}\n\n/* ── Month view ─────────────────────────────────────────── */\n.cal-month {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.cal-month-header {\n  display: grid;\n  grid-template-columns: 28px repeat(7, 1fr);\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n.cal-wk-header-label {\n  font-size: 10px;\n  color: var(--text-muted);\n  text-align: center;\n  padding: 4px 0;\n  text-transform: uppercase;\n  border-right: 1px solid var(--border);\n}\n.cal-month-dow {\n  text-align: center;\n  font-size: 11px;\n  color: var(--text-secondary);\n  padding: 4px 0;\n  text-transform: uppercase;\n}\n\n.cal-month-grid {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 28px repeat(7, 1fr);\n  grid-auto-rows: 1fr;\n  overflow: hidden;\n}\n\n.cal-wk-num {\n  font-size: 10px;\n  color: var(--text-muted);\n  text-align: center;\n  padding-top: 6px;\n  border-right: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  cursor: pointer;\n  user-select: none;\n}\n.cal-wk-num:hover { color: var(--accent-light); }\n\n.cal-month-cell {\n  border-right: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n  padding: 3px 4px;\n  min-height: 0;\n  overflow: hidden;\n  cursor: pointer;\n  position: relative;\n}\n.cal-month-cell:hover { background: rgba(255,255,255,0.03); }\n.cal-month-cell.other-month .cal-day-num { color: var(--text-muted); }\n.cal-month-cell.today .cal-day-num {\n  background: var(--accent);\n  color: #fff;\n  border-radius: 50%;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cal-day-num {\n  font-size: 11px;\n  color: var(--text-secondary);\n  margin-bottom: 2px;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cal-month-event {\n  font-size: 11px;\n  padding: 1px 4px;\n  border-radius: 2px;\n  margin-bottom: 1px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  color: #fff;\n}\n.cal-month-event:hover { filter: brightness(1.15); }\n\n.cal-more-link {\n  font-size: 10px;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 0 4px;\n}\n.cal-more-link:hover { color: var(--text-primary); }\n\n/* ── Week view ──────────────────────────────────────────── */\n.cal-week {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.cal-week-header {\n  display: grid;\n  grid-template-columns: 48px repeat(7, 1fr);\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n.cal-week-header-gutter { border-right: 1px solid var(--border); }\n.cal-wk-num-header {\n  font-size: 10px;\n  color: var(--text-muted);\n  text-align: center;\n  padding: 4px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.cal-week-header-day {\n  text-align: center;\n  padding: 4px 2px;\n  font-size: 12px;\n  border-right: 1px solid var(--border);\n}\n.cal-week-header-day .dow { color: var(--text-secondary); font-size: 10px; text-transform: uppercase; display: block; }\n.cal-week-header-day .dom {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n}\n.cal-week-header-day.today .dom { background: var(--accent); color: #fff; }\n\n.cal-week-body {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 48px repeat(7, 1fr);\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.cal-week-time-col {\n  border-right: 1px solid var(--border);\n  position: relative;\n}\n.cal-hour-label {\n  font-size: 10px;\n  color: var(--text-muted);\n  text-align: right;\n  padding-right: 4px;\n  height: 48px;\n  line-height: 1;\n  padding-top: 2px;\n  box-sizing: border-box;\n}\n\n.cal-week-day-col {\n  border-right: 1px solid var(--border);\n  position: relative;\n  cursor: pointer;\n}\n.cal-week-day-col:hover { background: rgba(255,255,255,0.015); }\n.cal-hour-line {\n  border-top: 1px solid var(--border);\n  height: 48px;\n  box-sizing: border-box;\n  pointer-events: none;\n}\n\n.cal-week-event {\n  position: absolute;\n  left: 2px;\n  right: 2px;\n  border-radius: 3px;\n  padding: 2px 4px;\n  font-size: 11px;\n  overflow: hidden;\n  cursor: pointer;\n  color: #fff;\n  box-sizing: border-box;\n  z-index: 1;\n}\n.cal-week-event:hover { filter: brightness(1.15); z-index: 2; }\n\n/* ── Day view ───────────────────────────────────────────── */\n.cal-day {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.cal-day-header {\n  text-align: center;\n  padding: 6px;\n  font-size: 14px;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.cal-day-body {\n  flex: 1;\n  display: grid;\n  grid-template-columns: 48px 1fr;\n  overflow-y: auto;\n}\n\n.cal-day-event-col {\n  position: relative;\n  cursor: pointer;\n}\n.cal-day-event-col:hover { background: rgba(255,255,255,0.015); }\n\n.cal-day-event {\n  position: absolute;\n  left: 4px;\n  right: 4px;\n  border-radius: 3px;\n  padding: 3px 6px;\n  font-size: 12px;\n  overflow: hidden;\n  cursor: pointer;\n  color: #fff;\n  box-sizing: border-box;\n}\n.cal-day-event:hover { filter: brightness(1.15); }\n\n/* ── Event form modal ────────────────────────────────────── */\n.cal-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.cal-modal {\n  background: var(--bg-secondary);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 20px;\n  width: 480px;\n  max-width: 96vw;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n\n.cal-modal h3 {\n  margin: 0 0 16px;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.cal-form-row {\n  margin-bottom: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.cal-form-row label {\n  font-size: 11px;\n  color: var(--text-secondary);\n  text-transform: uppercase;\n}\n.cal-form-row input,\n.cal-form-row select,\n.cal-form-row textarea {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  color: var(--text-primary);\n  border-radius: 3px;\n  padding: 5px 8px;\n  font-size: 13px;\n  width: 100%;\n  box-sizing: border-box;\n}\n.cal-form-row textarea { resize: vertical; min-height: 60px; }\n.cal-form-row input:focus, .cal-form-row select:focus, .cal-form-row textarea:focus {\n  outline: none;\n  border-color: var(--accent);\n}\n\n.cal-form-inline {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n.cal-form-inline input[type=\"checkbox\"] { width: auto; }\n.cal-form-inline label { font-size: 13px; color: var(--text-primary); text-transform: none; }\n\n.cal-color-row {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n  margin-top: 4px;\n}\n.cal-color-swatch {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  cursor: pointer;\n  border: 2px solid transparent;\n}\n.cal-color-swatch.selected { border-color: #fff; }\n\n.cal-recur-section {\n  border: 1px solid var(--border);\n  border-radius: 4px;\n  padding: 10px;\n  margin-top: 4px;\n}\n.cal-recur-row {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  margin-bottom: 8px;\n  flex-wrap: wrap;\n}\n.cal-recur-row:last-child { margin-bottom: 0; }\n.cal-recur-row label { font-size: 12px; color: var(--text-secondary); white-space: nowrap; }\n.cal-recur-row input, .cal-recur-row select {\n  background: var(--bg-primary);\n  border: 1px solid var(--border);\n  color: var(--text-primary);\n  border-radius: 3px;\n  padding: 3px 6px;\n  font-size: 12px;\n}\n\n\n.cal-modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 16px;\n}\n.cal-modal-actions .btn-danger {\n  margin-right: auto;\n}\n\n/* ── All-day row in week/day ────────────────────────────── */\n.cal-allday-row {\n  display: grid;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n  min-height: 24px;\n}\n.cal-allday-gutter {\n  border-right: 1px solid var(--border);\n  font-size: 10px;\n  color: var(--text-muted);\n  padding: 3px 4px;\n  text-align: right;\n}\n.cal-allday-cell {\n  border-right: 1px solid var(--border);\n  padding: 2px 2px;\n  min-height: 24px;\n}\n.cal-allday-event {\n  font-size: 11px;\n  padding: 1px 4px;\n  border-radius: 2px;\n  color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: pointer;\n  margin-bottom: 1px;\n}\n\n/* ── Now line ───────────────────────────────────────────── */\n.cal-now-line {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #e74c3c;\n  z-index: 5;\n  pointer-events: none;\n}\n.cal-now-line::before {\n  content: '';\n  position: absolute;\n  left: -4px;\n  top: -4px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #e74c3c;\n}\n\n@media (max-width: 768px) {\n  .cal-toolbar {\n    flex-wrap: wrap;\n    gap: 6px;\n  }\n  .cal-toolbar-title { min-width: 0; font-size: 13px; text-align: center; flex: 1; }\n  .cal-nav-group {\n    order: 10;\n    width: 100%;\n    justify-content: center;\n    border-top: 1px solid var(--border);\n    padding-top: 6px;\n  }\n  .cal-month-event { font-size: 10px; }\n  .cal-month-event-time { display: none; }\n  .cal-modal { padding: 14px; }\n}\n\n\n/* ── KSE Pro additions ──────────────────────────────────── */\n.cal-btn { display: inline-flex; align-items: center; gap: 4px; }\n.cal-btn:disabled { opacity: .5; cursor: default; }\n.cal-new-btn { display: inline-flex; align-items: center; gap: 4px; white-space: nowrap; }\n.cal-month-cell.weekend { background: rgba(127,127,127,0.04); }\n.cal-event-loc { opacity: .85; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.cal-week-event strong { display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }\n.cal-error { padding: 6px 12px; font-size: 12px; color: #f48771; border-bottom: 1px solid var(--border); }\n\n.cal-picker-wrap { position: relative; }\n.cal-picker {\n  position: absolute; right: 0; top: calc(100% + 4px); z-index: 50;\n  width: 280px; max-height: 60vh; overflow-y: auto;\n  background: var(--bg-secondary); border: 1px solid var(--border); border-radius: 6px;\n  box-shadow: 0 8px 24px rgba(0,0,0,.35); padding: 6px 0;\n}\n.cal-pick-section { font-size: 10px; text-transform: uppercase; letter-spacing: .06em; color: var(--text-muted); padding: 8px 12px 4px; }\n.cal-pick-row { display: flex; align-items: center; gap: 8px; padding: 5px 12px; font-size: 13px; cursor: pointer; }\n.cal-pick-row:hover { background: var(--bg-hover); }\n.cal-pick-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; border: 1px solid var(--border); }\n.cal-pick-label { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.cal-pick-empty { padding: 4px 12px; font-size: 12px; color: var(--text-muted); }\n\n.cal-form-pair { display: grid; grid-template-columns: 1fr; }\n.cal-dt { display: flex; gap: 6px; }\n.cal-dt input[type=\"date\"] { flex: 1; min-width: 0; }\n.cal-dt input[type=\"time\"] { width: 120px; flex-shrink: 0; }\n.cal-form-hint { font-size: 11px; color: var(--text-muted); }\n.cal-form-note { font-size: 12px; color: var(--text-muted); margin: -8px 0 12px; }\n.cal-form-error { font-size: 12px; color: #f48771; margin-top: 4px; }\n.cal-color-default { position: relative; }\n.cal-color-default::after { content: ''; position: absolute; inset: 6px; border-radius: 50%; background: rgba(255,255,255,.85); }\n.cal-view-row { font-size: 13px; margin-bottom: 8px; line-height: 1.45; }\n.cal-view-muted { color: var(--text-muted); font-size: 12px; }\n.cal-view-desc { white-space: pre-wrap; color: var(--text-secondary); }\n\n@media (max-width: 768px) {\n  .cal-picker { position: fixed; left: 8px; right: 8px; top: 100px; width: auto; max-height: 70vh; }\n  .cal-month-cell { padding: 2px; }\n  .cal-month-event { padding: 0 2px; }\n  .cal-week-event { font-size: 10px; padding: 1px 2px; }\n  .cal-event-loc { display: none; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
